import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import ProductsAndServicesItemsBlockData from 'app/Models/Content/ProductsAndServicesItemsBlockData';
import OurPartnersItemBlockData from 'Models/Content/OurPartnersItemBlockData';
import React, {memo} from 'react';
import {isMobile} from 'react-device-detect';
import {Container} from 'reactstrap';
import {getImageProps} from 'app/utilities/ImageProps';

const OurPartnersItemsBlock = ({data, context}: ComponentProps<ProductsAndServicesItemsBlockData>) => {
  const {fadeClass, ref} = useFadeIn();

  const noBottomBorder = (length, inRow, i) => {
    if (inRow >= length) {
      return true;
    }

    const rest = length % inRow;
    if (!rest) {
      return i >= length - inRow;
    } else {
      if (!isMobile) {
        return i >= Math.floor(length / inRow) * inRow - 1;
      } else {
        return i > Math.floor(length / inRow) * inRow - 1;
      }
    }
  };

  return (
    <div ref={ref} className={`OurPartnersItemsBlock ${fadeClass}`}>
      <h3 className='OurPartnersItemsBlock__title'>{data.title.value}</h3>

      <p className='OurPartnersItemsBlock__subtitle'>{data.subtitle.value}</p>

      <Container className='OurPartnersItemsBlock__items '>
        {data.items.expandedValue.map((item: OurPartnersItemBlockData, i) => {
          return (
            <div
              key={i}
              className={`OurPartnersItemsBlock__items__item ${
                noBottomBorder(data.items.expandedValue.length, isMobile ? 2 : 3, i) ? 'no-border-bottom' : ''
              }`}>
              <Image {...getImageProps(item.titleAsImage, context)} />
            </div>
          );
        })}
      </Container>
    </div>
  );
};

export default memo(OurPartnersItemsBlock);
